import { useState } from "react";
import { Alert } from "react-bootstrap";

export function OnboardingBanner({
    facilityId,
    facilityName,
    show,
}: {
    facilityId: number;
    facilityName: string;
    show: boolean;
}) {
    const [dismissed, setDismissed] = useState(false);

    if (!show || dismissed) return null;

    return (
        <Alert variant="warning" className="d-flex align-items-center justify-content-between mb-2 rounded-0 border-0 border-bottom">
            <span>
                <b>Warning:</b> Stripe onboarding has not been completed for {facilityName}. <b>You will not be able to receive payments for this lot.</b> Please contact SpotSync support to complete your onboarding.
            </span>
            <button
                type="button"
                className="btn-close"
                aria-label="Dismiss"
                onClick={() => setDismissed(true)}
            />
        </Alert>
    );
}
